// extracted by mini-css-extract-plugin
module.exports = {"layout":"speaker-grid_layout__dmdJJ"};